export type SyncKind = 'FULL' | 'INCREMENTAL';

/**
 * Decide which sync button ("Sync now" = INCREMENTAL, "Re-sync all" = FULL)
 * shows the inline "Syncing…" label.
 *
 * Only the button the user CLICKED this session (`clickedKind`) is labelled.
 * `sync.variables` from TanStack Query survives the isPending→isSyncing handoff,
 * so the label never flips to the other button when the running job's kind
 * differs (e.g. clicking "Sync now" while the connect-triggered FULL sync is
 * still active). When no click was tracked this session (connect-triggered sync
 * or a page reload mid-sync) we deliberately label NEITHER button — both are
 * disabled and the card header carries the "Syncing now…" progress instead, so
 * the user never sees "Syncing…" on a button they didn't press. Idle ⇒ null.
 */
export function resolveActiveKind(args: {
  busy: boolean;
  clickedKind: SyncKind | null;
}): SyncKind | null {
  return args.busy ? args.clickedKind : null;
}
